import React, { useState, useEffect } from 'react';
import { Badge, Button, Card, Modal, Table } from 'react-bootstrap';
import { IoAddOutline } from 'react-icons/io5';
import generateUniqueId from 'generate-unique-id';
import SetupForm from '../../../components/forms/customers/setup-form';
import { useNavigate } from 'react-router';
import axios from 'axios';
import { useAuth } from './../../../context/AuthContext';
import { toast } from 'react-toastify';

function Businesses() {

  const navigate = useNavigate();
  const { user } = useAuth();

  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [businesses, setBusinesses] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  async function listAllBusinesses(accessToken, uid) {
    let config = {
      method: 'get',
      url: `${process.env.REACT_APP_FIREBASE_PROVIDER_URL}/businesses`,
      headers: {
        "idToken": accessToken,
        "uid": uid
      }
    };

    axios.request(config)
      .then((response) => {
        if (response.status === 200) {
          setBusinesses(response.data);
          setIsLoading(false);
        }
      }).catch((error) => {
        console.log('Error :', error);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    if (user) {
      listAllBusinesses(user.accessToken, user.uid);
    }
  }, []);

  async function handleBusinessData(data) {
    const uid = generateUniqueId();

    let config = {
      method: 'post',
      url: `${process.env.REACT_APP_FIREBASE_PROVIDER_URL}/create-business`,
      headers: {
        "idToken": user.accessToken,
        "uid": user.uid
      },
      data: { ...data, uid: uid, createdOn: new Date() }
    };
    axios.request(config)
      .then((response) => {
        if (response.status === 201) {
          handleClose();
          toast.success('Business created, Successfully.');
        }
      }).catch((error) => {
        toast.error(error && error.message);
      });
  }

  return (
    <section className='p-3'>
      <div className='sticky-top bg-white rounded p-3 mb-3'>
        <div className='row align-items-center justify-content-center'>
          <div className='col-md-10'>
            <h3 className='mb-0'>Businesses</h3>
          </div>
          <div className='col-md-2 d-flex align-items-center justify-content-end'>
            <Button
              variant='primary'
              className='px-4 py-2'
              onClick={handleShow}
            >
              <IoAddOutline size={24} />
              <span className='ms-2'>Add New</span>
            </Button>
          </div>
        </div>
      </div>
      <Card className='p-3 border-0 shadow-sm'>
        <Table hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Business Name</th>
              <th className='text-center'>Phone Number</th>
              <th className='text-center'>State</th>
              <th className='text-center'>Status</th>
            </tr>
          </thead>
          <tbody>
            {
              businesses && businesses.length !== 0 ?
                businesses.map((item, index) => {
                  return (
                    <tr
                      key={index}
                      onClick={() => navigate(`details/${item.id}`, { state: item })}
                      className='cursor-pointer'
                    >
                      <td>{index + 1}</td>
                      <td>{item.businessName}</td>
                      <td className='text-center'>+91 {item.phoneNumber}</td>
                      <td className='text-center'>{item.state}</td>
                      <td className='text-center'>
                        {
                          item.status === 'active' ?
                            <Badge bg="success" className='fw-normal'>
                              Active
                            </Badge>
                            : item.status === 'suspended' ?
                              <Badge bg="danger" className='fw-normal'>
                                Suspended
                              </Badge>
                              : item.status === 'cancelled' ?
                                <Badge bg="danger" className='fw-normal'>
                                  Not Subscribe Yet!
                                </Badge>
                                :
                                <Badge bg="dark" className='fw-normal'>
                                  No Subscription
                                </Badge>
                        }
                      </td>
                    </tr>
                  )
                })
                :
                <tr>
                  <td colSpan={5}>
                    <h4 className='text-center py-4 text-muted mb-0'>No Business Found</h4>
                  </td>
                </tr>
            }
          </tbody>
        </Table>
      </Card>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size={'lg'}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SetupForm
            handleClose={handleClose}
            handleData={handleBusinessData}
          />
        </Modal.Body>
      </Modal>
    </section>
  );
}

export default Businesses;
